import palette from "../palette";

export default {
  iconButton: {
    backgroundColor: "none"
  },
  dayLabel: {
    color: palette.text.secondary
  }
};
